import { memo, useCallback } from 'react';

const FloatLabelInput = memo(({ title, onUpdate = () => { }, value = "", fieldKey = undefined }) => {
    const handleChange = useCallback((e) => {
        onUpdate(prev => ({ ...prev, [fieldKey]: e.target.value }));
    }, [fieldKey, onUpdate]);

    return (
        <div
            style={{ border: '1px solid #dee2e6' }}
            className="tw-relative tw-px-2 tw-max-h-10 tw-w-full tw-rounded-lg tw-bg-white tw-my-1"
        >
            <div className={`tw-flex tw-items-center tw-h-10 tw-gap-2`}>
                <input
                    id={fieldKey ?? title}
                    type={'text'}
                    value={value}
                    onChange={handleChange}
                    className={`tw-bg-transparent tw-w-full tw-text-sm tw-font-normal tw-border-none tw-outline-none tw-peer tw-z-10 tw-relative tw-transition-all tw-h-10`}
                />
                <label
                    htmlFor={title}
                    className={`tw-absolute -tw-top-[10px] tw-right-3 tw-z-20 tw-px-2 tw-text-[12px] tw-font-medium tw-bg-white tw-w-fit tw-transition-all tw-duration-200 tw-text-[#212529]`}
                >
                    {title}
                </label>
            </div>
        </div>
    );
});

FloatLabelInput.displayName = 'FloatLabelInput';

export default FloatLabelInput;